import React, { useCallback, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import { TextField, Typography } from "@mui/material";

/*
USAGE
import 
...
const [getConfirmation, ConfirmationDialog] = useConfirm();
...
const status = await getConfirmation({ title: 'Tallenna', text: 'ootko varma', okText: 'Ok', cancelText: 'Ei' });
...
<ConfirmationDialog />
*/

const createPromise = () => {
  let resolver;
  return [
    new Promise((resolve, reject) => {
      resolver = resolve;
    }),
    resolver,
  ];
};

const useDeleteConfirm = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [resolver, setResolver] = useState({ resolver: null });
  const [label, setLabel] = useState({ title: "", text: "", okText: "", cancelText: "", itemName: "" });

  //params:{title,text, okText,cancelText}
  const getDeleteConfirmation = async (params) => {
    setLabel(params);
    setOpen(true);
    const [promise, resolve] = await createPromise();
    setResolver({ resolve });
    return promise;
  };

  const onClick = async (status) => {
    setOpen(false);
    resolver.resolve(status);
  };

  const DeleteConfirmationDialog = () => {
    const [deleteConfirmText, setDeleteConfirmText] = useState("");

    const handleInputChange = useCallback((e) => {
      setDeleteConfirmText(e.target.value);
    }, []);

    return (
      <Dialog
        open={open}
        // onClose={() => onClick(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        // modalType="alert"
      >
        <DialogTitle id="alert-dialog-title" sx={{ color: "error.main" }}>
          {label.title} - {label.itemName}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{label.text}</DialogContentText>
          <TextField name="deleteConfirmText" value={deleteConfirmText} onChange={handleInputChange} />
        </DialogContent>
        <DialogActions>
          <Button color="primary" variant="outlined" onClick={() => onClick(false)}>
            {label.cancelText}
          </Button>
          <Button
            color="error"
            variant="outlined"
            disabled={deleteConfirmText !== "DELETE"}
            onClick={() => onClick(true)}
          >
            {label.okText}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  return [getDeleteConfirmation, DeleteConfirmationDialog];
};

export default useDeleteConfirm;
